export const BOTTOM_BAR_CONTENT_CONTAINER_ID = 'BOTTOM_BAR_CONTENT_CONTAINER_ID';
